export class WhitelistApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getWhitelists({ companyId }) {
    return this.#http.get('/api/whitelists', { params: { companyId } });
  }

  async createWhitelists(whitelists) {
    return this.#http.post('/api/whitelists', whitelists);
  }

  async deleteWhitelists(whitelists) {
    return this.#http.delete('/api/whitelists', { data: whitelists });
  }
}
